import { motion } from "framer-motion";
import { useState } from "react";
import { BiMessageSquare, BiPhone, BiUser } from "react-icons/bi";
import { CgMail } from "react-icons/cg";

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const now = new Date();
      const sentAt = `${now.getDate()}/${
        now.getMonth() + 1
      }/${now.getFullYear()} ${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
      const params = new URLSearchParams({
        ...formData,
        source: "apponitment",
        sentAt,
      });

      const response = await fetch(
        `https://script.google.com/macros/s/AKfycbxfiShQj3_aBjS3MrIrRSjT1cWJy4jOsoFJE7jhuvyhM9yZ0aQW4VB3-P-R4GMDSXvnOw/exec?${params.toString()}`,
        {
          method: "GET",
        }
      );

      const result = await response.json();

      if (result.status === "success") {
        alert("Contact form submitted successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        alert("Error: " + result.message);
      }
    } catch (error) {
      console.error(error);
      alert("Something went wrong. Check console for details.");
    } finally {
      setLoading(false);
    }
  };

  const container = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.15 } },
  };
  const fieldProps = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: false, amount: 0.2 },
  };

  return (
    <motion.div
      className="max-w-md w-full mx-auto p-8 bg-white rounded-3xl shadow-2xl"
      initial="hidden"
      animate="visible"
      variants={container}
    >
      <motion.h2
        className="text-3xl font-bold text-pink-600 mb-6 text-center"
        {...fieldProps}
        transition={{ duration: 0.3 }}
      >
        Contact Us
      </motion.h2>

      <form onSubmit={handleSubmit} className="flex flex-col gap-6">
        <motion.div
          className="relative z-0 w-full group"
          {...fieldProps}
          transition={{ duration: 0.3, delay: 0.2 }}
        >
          <input
            type="text"
            name="name"
            id="name"
            placeholder=" "
            value={formData.name}
            onChange={(e) => handleChange("name", e.target.value)}
            className="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-pink-600 peer"
            required
          />
          <label
            htmlFor="name"
            className="absolute text-gray-500 text-sm duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
          >
            <BiUser className="inline mr-1" />
            Your Name
          </label>
        </motion.div>

        <motion.div
          className="relative z-0 w-full group"
          {...fieldProps}
          transition={{ duration: 0.3, delay: 0.4 }}
        >
          <input
            type="email"
            name="email"
            id="email"
            placeholder=" "
            value={formData.email}
            onChange={(e) => handleChange("email", e.target.value)}
            className="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-pink-600 peer"
            required
          />
          <label
            htmlFor="email"
            className="absolute text-gray-500 text-sm duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
          >
            <CgMail className="inline mr-1" />
            Your Email
          </label>
        </motion.div>

        <motion.div
          className="relative z-0 w-full group"
          {...fieldProps}
          transition={{ duration: 0.3, delay: 0.6 }}
        >
          <input
            type="tel"
            name="phone"
            id="phone"
            placeholder=" "
            pattern="[0-9]{7,15}"
            value={formData.phone}
            onChange={(e) => handleChange("phone", e.target.value)}
            className="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-pink-600 peer"
            required
          />
          <label
            htmlFor="phone"
            className="absolute text-gray-500 text-sm duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
          >
            <BiPhone className="inline mr-1" />
            Phone Number
          </label>
        </motion.div>

        <motion.div
          className="relative z-0 w-full group"
          {...fieldProps}
          transition={{ duration: 0.3, delay: 0.6 }}
        >
          <textarea
            name="message"
            id="message"
            rows="2"
            placeholder=" "
            value={formData.message}
            onChange={(e) => handleChange("message", e.target.value)}
            className="block py-2.5 px-0 w-full text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-pink-600 peer resize-none"
            required
          />
          <label
            htmlFor="message"
            className="absolute text-gray-500 text-sm duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
          >
            <BiMessageSquare className="inline mr-1" />
            Your Message
          </label>
        </motion.div>

        <button
          disabled={loading}
          type="submit"
          className="mt-4 w-full py-3 bg-pink-600 text-white font-medium rounded-lg shadow hover:bg-pink-700 transition-all duration-300 cursor-pointer text-center disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Submit
        </button>
      </form>
    </motion.div>
  );
};

export default Contact;
